import React from 'react';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import ChevronRightIcon from '@ps-design-system/icons/ChevronRight/ChevronRight24';

import { ButtonSelector } from './components/button-selector';
import { useFlagMessageContext } from './utils/utils';

export const FlagReasonFlow = () => {
  const { flagData, setSelectedReason, setCurrentStep } = useFlagMessageContext();

  return <div className="flag-message-modal-body">
    <p className="flag-message-modal-text">
      <FormattedMessage
        id="stream.flag_message.select_reason"
        defaultMessage="Please select the issue you are having. This will only be shared with Peerspace."
      />
    </p>
    <hr className="no-margin" />
    <div className="flag-message-modal-buttons flex middle space-between column">
      {map(flagData, (reason => {
        const onClick = () => {
          setSelectedReason(reason);
          setCurrentStep(isEmpty(reason.categories) ? 'details' : 'category');
        };

        return <>
          <ButtonSelector onClick={onClick}>
            <div className="button-body flex space-between middle full-width">
              <span className="capitalize-first-letter">
                {reason.title}
              </span>
              <ChevronRightIcon />
            </div>
          </ButtonSelector>
          <hr className="no-margin full-width" />
        </>;
      }))}
    </div>
  </div>;
};
